module.exports = __webpack_public_path__ + "img/vessel_visitation_1_63021.2d0477b6.jpg";